import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ModelID, Vehicle } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { featureKeys, featurePath, VehicleSearchParams } from '.';

type QueryFnType = typeof fetchVehicles;

type UseVehiclesOptions = {
  location: ModelID;
  search?: VehicleSearchParams;
  config?: QueryConfig<QueryFnType>;
};

export const fetchVehicles = (location: ModelID, search: VehicleSearchParams = {}) =>
  get<Vehicle[]>(`${featurePath}?franchise_id=${location}`, search);

export const useVehicles = ({ location, search = {}, config = {} }: UseVehiclesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.list(location, search),
    queryFn: () => fetchVehicles(location, search),
  });
};
